import { render, staticRenderFns } from "./CreateUserComponent.vue?vue&type=template&id=ba22be48&scoped=true&"
import script from "./CreateUserComponent.vue?vue&type=script&lang=js&"
export * from "./CreateUserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba22be48",
  null
  
)

export default component.exports